import styled from '@emotion/styled';
import { Box } from '@rebass/emotion';
import { rem } from '@app/styles/theme/layout';
import { AppTheme } from '@app/styles/theme';

export const ContentWrapper = styled(Box)`
  max-width: ${rem(1170)};
  margin: 0 auto;
  width: 100%;
`;

export const ContentTop = styled(Box)<{ theme: AppTheme }>`
  text-align: center;
  h1,
  h2,
  h3 {
    font-size: 2.5rem;
  }
  .text-body,
  p {
    font-size: 1rem;
    line-height: 1.8;
  }
  /* stylelint-disable no-descending-specificity */
  a {
    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.colors.protectedContentLinkHover};
      transition: color 0.3s;
    }
  }
`;

export const FindDealerButton = styled.a<{ theme: AppTheme }>`
  text-align: center;
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  line-height: 1.3;
  padding: ${rem(7)} ${rem(13)};
  font-family: ${({ theme }) => theme.fonts.fontSemi};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${({ theme }) => theme.colors.darkGray};
    transition: background-color 0.3s;
  }
`;

export const ExtraInformation = styled(Box)<{ theme: AppTheme }>`
  font-style: italic;
  font-size: ${rem(13)};
  line-height: 1.2rem;
`;
